import { Card } from '@fabric-ds/react';
import * as React from 'react';
import { TImprovedContentMarketing } from '../../../../shared/types/contentMarketing';

type Props = {
    contentMarketing: TImprovedContentMarketing;
    children: any;
    className?: string;
};
const FabricAnchorCard = ({ children, className = '' }: Props) => {
    return <Card className={className}>{children}</Card>;
};

export default FabricAnchorCard;

export const NonCardAnchorWrapper = ({ children }: Props) => {
    return (
        <div
            className={`relative h-full w-full overflow-hidden transition-all rounded-8 hover:bg-aqua-50 p-8`}
        >
            {children}
        </div>
    );
};
